module.exports = __webpack_public_path__ + "static/media/invite-area-creation.c9dc2ebb.webp";